import { 
    SSPAREPRESENTATIVE_BEGIN,
    SSPAREPRESENTATIVE_ADD,
    SSPAREPRESENTATIVE_FAILURE,
    SSPAREPRESENTATIVE_CLEAR,

    SSPAREPRESENTATIVE_FILTER_BEGIN,
    SSPAREPRESENTATIVE_FILTER_SUCCESS,
    SSPAREPRESENTATIVE_FILTER_FAILURE,
    SSPAREPRESENTATIVE_FILTER_CLEAR

} from 'app/actions/SSPARepresentativeActions';

const initialState = {
    allIds: [],
    filterData: [],
	isLoading: false,
};

export default function SSPARepresentativeReducer (state = initialState, action) {
	switch (action.type) {
        case SSPAREPRESENTATIVE_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case SSPAREPRESENTATIVE_ADD:
            let allIds = action.payload.data.Data;

			return {
				...state,
				allIds,
				isLoading: false,
            };
        case SSPAREPRESENTATIVE_CLEAR:
            return {
                ...state,
                allIds: [],
                isLoading: false,
            }
        case SSPAREPRESENTATIVE_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case SSPAREPRESENTATIVE_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case SSPAREPRESENTATIVE_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case SSPAREPRESENTATIVE_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case SSPAREPRESENTATIVE_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}
};

export const getSSPARepresentative = state => {
	return state.allIds;
}

export const getIsLoadingSSPARepresentative = state => {
    return state.isLoading;
}

export const getSSPARepresentativeFilter = state => {
    return state.filterData
}
export const getIsLoadingSSPARepresentativeFilter = state => {
    return state.isLoading;
}